<template>
	<el-card v-show="vitals.length > 0">
		<div slot="header" class="vital header">
			<img src="../image/vital_new.png" class="header-icon">
			<span class="header-title">Vitals</span>
		</div>
		<VitalTable :patient="patient" v-bind:vitals="vitals"></VitalTable>
	</el-card>
</template>

<script>
import OverviewCard from '..'
import VitalTable from './Table'

export default {
	name: 'patient-vital-card',
	extends: OverviewCard,

	computed: {
		vitals() {
			return this.patientEventType('vital')
		}
	},

	components: {
		VitalTable
	}
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
</style>
